import { z } from 'zod';
import { draftedProductTypeValues } from 'src/apis/capacity-management/mappings';
import { getPaginationSchema } from 'src/components/form/zod-schemas';
import { preprocessAsArray } from 'src/components/form/zod-utilities';
import { ownNetworkPointSchema } from 'src/pages/transport/products/drafted/overview/own-network-searchable-multi-select';

export const draftedProductsOverviewSchema = z.object({
  networkPointId: z.preprocess(
    preprocessAsArray,
    z.array(ownNetworkPointSchema).default([])
  ),
  capacityCategoryId: z.preprocess(
    preprocessAsArray,
    z.array(z.string()).default([])
  ),
  productType: z.preprocess(
    preprocessAsArray,
    z.array(z.enum(draftedProductTypeValues)).default([])
  ),
  runtimeStartFrom: z.string().nullable().default(null),
  runtimeStartTo: z.string().nullable().default(null),
  ...getPaginationSchema().shape,
});
